

export const validateCreateMisFieldForm = (misFormData) => {
    let isValidCheckMsg = isValid(misFormData);
    if (isValidCheckMsg)
        return isValidCheckMsg;

    if (isRequiredFieldsEmpty(misFormData)) {
        return 'Please enter all required fields';
    }
    return '';
}

const isValid = (misFormData) => {
    for (let key in misFormData) {
        let value = misFormData[key];
        if (typeof value == 'string') {
            let res = !value || value.match(/^[^<>!$%^?*~`{}=]*$/) ? null : 'Please enter valid Input';
            if (res) {
                return res;
            }
        }
    }
    return null;

}

const isRequiredFieldsEmpty = (misFormData) => {

    if (!misFormData.name || misFormData.name === '') {
        return true;
    }
    if (!misFormData.keyType || misFormData.keyType === '') {
        return true;
    }
    if (!misFormData.formCategory || misFormData.formCategory === '') {
        return true;
    }
    if (!misFormData.dataType || misFormData.dataType === '') {
        return true;
    }
    if (!misFormData.fieldType || misFormData.fieldType === '') {
        return true;
    }
    return false;

}

export const transformToMisFieldReqBody = (misFormData) => {
    let value = null;
    if (misFormData.values && misFormData.values.length>0) {
        const valueArr = misFormData.values.split(",");
        if (valueArr && valueArr.length !== 0)
            value = valueArr;
    }

    let misReqBody = {
        name: misFormData.name,
        keyType: misFormData.keyType,
        formCategory: misFormData.formCategory,
        data:
        {
            dataType: misFormData.dataType,
            values: value
        },
        masterKey: misFormData.masterKey,
        fieldType: misFormData.fieldType
    }
    return misReqBody;
}

export const transformToMasterKeySelectData=(masterDataList)=>
{
    const tmpArr=[];
    if(masterDataList)
    {
    masterDataList.forEach(item => {
        if(item && item.name && item.name.length>0)
            tmpArr.push({ value: item.name, label: item.name });
    })
    }
    return tmpArr;
}